APPS.landingPages.open_mic_registration = (function(){
    var show = function(){
            APP.getView().showChildView('mainRegion', new pageView({}) )
            
            window.document.title = "WHRO Classical Open Mic Registration";
            if(typeof ga != "undefined"){ ga('send','pageview',{ title:"WHRO Classical Open Mic Registration", page:"/open_mic_registration" }) }
			if(typeof gtag != "undefined"){ gtag('event', 'page_view', { 'page_title': "WHRO Classical Open Mic Registration", 'page_path': '/open_mic_registration', 'page_location': window.location.origin+"/open_mic_registration" }); }
            if(typeof submitVisitorDetails ==="function"){ submitVisitorDetails(APP_CONFIG.rpi.server, APP_CONFIG.rpi.clientId, "WHRO Classical Open Mic Registration", '0', false, true); }
    }

    /* VIEWS */
    // THE PAGE
    var pageView = Marionette.View.extend({
         template:"#tmpl-landingPage-open-mic-registration"
        ,className:"page_landingPage_open_mic_registration my8"
        ,events:{
            "click #btnSubmitRequest"			: "submit",
            'blur.error-form  #instrument, #email, #title, #composer, #duration, #hear-about-event, #previously-performed-yes, #previously-performed-no, #waiting-list' : function(e){
	            var $this = $(e.currentTarget),
				    id = $this.attr('id');
				if( !$this.val().length ){
					this.$el.find('#error-'+id).show() 
				}else{
					this.$el.find('#error-'+id).hide() 
				}
            },
			"click #previously-performed-yes"  : function() {
				this.$el.find('#error-previously-performed').hide() 
			},
			"click #previously-performed-no"  : function() {
				this.$el.find('#error-previously-performed').hide() 
			},
			"click #waiting-list-yes"  : function() {
				this.$el.find('#error-waiting-list').hide() 
			},
			"click #waiting-list-no"  : function() {
				this.$el.find('#error-waiting-list').hide() 
			},			
        }
        ,submit:function(e){
	        e.preventDefault();
	        $('#messageContainer').hide();
			
			var formData = new FormData($('form')[0]);
			var errors = [], i = 0;
			var iterator, end=false;
			console.log("APP_CONFIG.MEDIA_API_ROOT", APP_CONFIG.MEDIA_API_ROOT)
			 //formData is difficult to console out without ES6 :p
			iterator = formData.entries();
			while(end === false) {
				var item = iterator.next();
				if(item.value!==undefined) {
					console.log(item.value)
					/* 
						When the radio buttons are not selected that basically means their value is undefined. So the FormData skips inputs with undefined values. 
						When you select the radio input it becomes available in the formData.
					*/
					if (!document.getElementById('previously-performed-yes').checked && !document.getElementById('previously-performed-no').checked) {
						errors[i++] = "previously-performed"
					}
					if (!document.getElementById('waiting-list-yes').checked && !document.getElementById('waiting-list-no').checked) {
						errors[i++] = "waiting-list"
					}
					if(item.value[0] === "email"){
						if(item.value[1] === "" || !(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(item.value[1]))){
							errors[i++] = item.value[0];
						}
					} else if(item.value[0] === "instrument" ||
							  item.value[0] === "email" ||
							  item.value[0] === "title" ||
							  item.value[0] === "composer" ||
							  item.value[0] === "duration" ||
							  item.value[0] === "hear-about-event")
							  {
								if(item.value[1] === ""){
									errors[i++] = item.value[0];
								};
					}
				} else if(item.done===true) {
					end = true;
				}
			}
			
			if(errors.length > 0){
				_.each(errors, function(item){
					$("#error-"+item).show();
				})
				
			}
			if(errors.length == 0){
				$.ajax({
					url: APP_CONFIG.MEDIA_API_ROOT+'openmicregistration',
					data: formData,
					processData: false,
					contentType: false,
					type: 'POST'
				}).done(function(res){
					if(res){
						var response = JSON.parse(res);						
						if(response.success === true){
							Backbone.Radio.channel('open_mic_registration').request("open_mic_registration_confirmation", {status: true});
						} else {
							var htm = "<h2 class='my4 danger'>Umm... there is an error.</h2>"
							htm += "<h2 class='my4 danger'>Please fill out fields.</h2>"
							$('#messageContainer').html(htm).show();
						}
							
					} else {
						var htm = "<h2 class='my4 danger'>Unknown error.</h2>"
						$('#messageContainer').html(htm).show();
					}
					
				});			
			}


        }
    })
    return {
        show:show
    }
})();


/// Confirmation page for Listener show request 
APPS.landingPages.open_mic_registration_confirmation = (function(){
	var show = function(){
		APP.getView().showChildView('mainRegion', new pageView({}) )
	}
	
			
	var pageView = Marionette.View.extend({
		 template:"#tmpl-landingPage-open-mic-registration-confirmation"
		 ,className:"page_landingPage_confirmation py8"
	}) 
	return {
		show:show
	}
})();




